import { Box, HStack } from '@chakra-ui/react';
import { InsuranceAuthorization } from '@web-app/graphql/healthie/queries/get-client-insurance-details/types';

import { VisitBarSectionItem } from './VisitBarSectionItem';
import { VisitsUsed } from './VisitsUsed';

type Props = {
  data: InsuranceAuthorization;
};

export const VisitsBar = ({ data }: Props) => {
  if (!data) {
    return null;
  }

  return (
    <>
      <VisitsUsed data={data} />

      {data.isUnlimitedVisits ? (
        <Box
          borderRadius={200}
          background="linear-gradient(90deg, #007855 0%, #5C52CE 51%, #FA6511 100%)"
          width="100%"
          height={6}
        />
      ) : (
        <HStack gap={1} wrap="nowrap" width="100%">
          {Array.from({ length: data.visitsAuthorized }, (_, index) => index)
            .filter((index) => index !== undefined)
            .map((index) => (
              <VisitBarSectionItem
                key={index}
                isUsed={index < data.visitsUsed}
              />
            ))}
        </HStack>
      )}
    </>
  );
};
